import React, { useEffect, useRef, useState } from "react";
import EzTable from "../../../common/EzTable";
import { EzToast, TOAST_SEVERITY } from "../../../common/EzToast";
import EzNotFound from "../../../common/EzNotFound";
import EzDialog from "../../../common/EzDialog";
import { Box, Container } from "@mui/material";
import Breadcrumb from "../../../common/Breadcrumb";
import { Button } from "primereact/button";
import { useStyles } from "./style";
import { vehicleBreadcrumbD } from "../VehicleTrim/CreateVehicleTrim/constant";
const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;
const VehicleVehicleOperations = (props) => {
  const classes = useStyles();
  const {
    fetchVehicleVehicleOperationss,
    tableData,
    setDeleteConfirmationPopupVisibility,
    exportVehicleVehicleOperations,
    isPageLevelError,
    paginationInfo,
    isLoading,
    screenPermissions,
    handleCreateVehicleVehicleOperations,
    editVehicleVehicleOperationsRoute,
    deleteVehicleVehicleOperations,
    isVehicleVehicleOperationsDeleteSuccess,
    isVehicleVehicleOperationsDeleteError,
    shouldOpenDeleteConfirmationPopup,
    savedTableState,
    onTableStateChange,
    importVehicleVehicleOperations,
    downloadVehicleImportTemplate,
    isVehicleVehicleOperationsImportSuccess,
    isVehicleVehicleOperationsImportError,
    vehicleImportResult,
    isDownloadTemplateLoading,
  } = props;
  const breadcrumbD = [
    { path: "/dashboard", label: "Dashboard" },
    { path: "/vehicle-make", label: "Vehicle Vehicle" },
  ];

  const [isCopy, setIsCopy] = useState(false);
  const [areFiltersVisible, toggleFilterState] = useState(true);
  const [isImportDialogVisible, setIsImportDialogVisible] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const convertToTSV = (data) => {
    const headers = data.columns.map((item) => item.colLabel).join("\t");
    //const headers = Object.keys(data.rows[0]).join('\t');
    const rows = data.rows
      .map((row) => Object.values(row).join("\t"))
      .join("\n");
    return `${headers}\n${rows}`;
  };

  const copyToClipboard = () => {
    const csv = convertToTSV(tableData);
    navigator.clipboard
      .writeText(csv)
      .then(() => setIsCopy(true))
      .catch((err) => setIsCopy(true));
  };
  useEffect(() => {
    setTimeout(() => setIsCopy(false), 1000);
  }, [isCopy]);

  useEffect(() => {
    if (isVehicleVehicleOperationsImportSuccess) {
      handleImportDialogHide();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVehicleVehicleOperationsImportSuccess]);

  const tableRef = useRef();
  const importInputRef = useRef();

  const handleFileSelect = (e) => {
    setSelectedFile(e.target.files[0] || null);
  };

  const handleImportSubmit = () => {
    if (!selectedFile) return;
    importVehicleVehicleOperations(selectedFile);
  };

  const handleImportDialogHide = () => {
    setIsImportDialogVisible(false);
    setSelectedFile(null);
    if (importInputRef.current) importInputRef.current.value = "";
  };

  const handlePrint = () => {
    const printContents = tableRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  const handleExportVehicleVehicleOperations = () => {
    exportVehicleVehicleOperations({
      pageNumber: paginationInfo?.pageNumber,
      pageSize: paginationInfo?.pageSize,
      paged: false,
      sort: `${savedTableState?.sortField || 'id'},${savedTableState?.sortOrder === 1 ? 'asc' : 'desc'}`,
    });
  };

  const renderImportDialog = () => {
    const dialogFooter = (
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <Button
          label="Cancel"
          icon="pi pi-times"
          className="p-button-text"
          onClick={handleImportDialogHide}
        />
        <Button
          label="Import"
          icon="pi pi-upload"
          className="p-button-raised"
          disabled={!selectedFile}
          onClick={handleImportSubmit}
        />
      </div>
    );
    return (
      <EzDialog
        visible={isImportDialogVisible}
        onHide={handleImportDialogHide}
        header="Import Vehicles"
        width="50vw"
        height="auto"
        maximizable={false}
        footer={dialogFooter}
      >
        <div style={{ padding: "0", display: "flex", flexDirection: "column", gap: "20px" }}>
          <div>
            <p style={{ margin: "0 0 8px 0", fontWeight: 600 }}>Step 1: Download the import template</p>
            <Button
              label={isDownloadTemplateLoading ? "Downloading..." : "Download Template"}
              icon="pi pi-download"
              className="p-button-outlined"
              disabled={isDownloadTemplateLoading}
              onClick={downloadVehicleImportTemplate}
            />
          </div>
          <div>
            <p style={{ marginBottom: "8px", fontWeight: 600 }}>Step 2: Upload the filled Excel file</p>
            <input
              ref={importInputRef}
              type="file"
              accept=".xlsx,.xls"
              style={{ display: "none" }}
              onChange={handleFileSelect}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #ced4da",
                borderRadius: "4px",
                overflow: "hidden",
                cursor: "pointer",
              }}
              onClick={() => importInputRef.current.click()}
            >
              <span
                style={{
                  padding: "8px 14px",
                  background: "#e9ecef",
                  borderRight: "1px solid #ced4da",
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                  fontSize: "14px",
                  userSelect: "none",
                }}
              >
                Choose File
              </span>
              <span
                style={{
                  padding: "8px 12px",
                  color: selectedFile ? "#333" : "#999",
                  fontSize: "14px",
                  flex: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {selectedFile ? selectedFile.name : "No file chosen"}
              </span>
            </div>
          </div>
          {vehicleImportResult && (
            <div style={{ borderTop: "1px solid #e0e0e0", paddingTop: "16px" }}>
              <p style={{ fontWeight: 600, marginBottom: "8px" }}>Import Result</p>
              <div style={{ display: "flex", gap: "24px", marginBottom: "12px" }}>
                <span>Total Rows: <strong>{vehicleImportResult.totalRows}</strong></span>
                <span style={{ color: "green" }}>Success: <strong>{vehicleImportResult.successCount}</strong></span>
                <span style={{ color: vehicleImportResult.failedCount > 0 ? "red" : "inherit" }}>
                  Failed: <strong>{vehicleImportResult.failedCount}</strong>
                </span>
              </div>
              {vehicleImportResult.errors?.length > 0 && (
                <div style={{ background: "#fff3f3", border: "1px solid #ffa0a0", borderRadius: "4px", padding: "10px", maxHeight: "140px", overflowY: "auto" }}>
                  <p style={{ fontWeight: 600, color: "#c00", marginBottom: "6px" }}>Row Errors:</p>
                  {vehicleImportResult.errors.map((err, i) => (
                    <p key={i} style={{ margin: "2px 0", fontSize: "13px", color: "#c00" }}>{err}</p>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </EzDialog>
    );
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">Vehicle</h4>
            <Button
              label={areFiltersVisible ? "Advanced Filter" : "Advanced Filter"}
              icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
              className={`p-button-text p-button-secondary shadow-btn`}
              onClick={() => {
                toggleFilterState(!areFiltersVisible);
              }}
            />
          </div>
          <div className="buttonarea">
            <div className="create-btn-group">
              {screenPermissions?.create && (
                <Button
                  label={"Create Vehicle"}
                  className={` p-button-raised`}
                  style={{ borderRadius: "0px" }}
                  onClick={handleCreateVehicleVehicleOperations}
                />
              )}
              <Button
                label={"Import"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={() => setIsImportDialogVisible(true)}
              />
            </div>
            <div className="copy-excel-print-group">
              <Button
                label={"Copy"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={copyToClipboard}
              />
              <Button
                label={"Excel"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={handleExportVehicleVehicleOperations}
              />
              <Button
                label={"Print"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={handlePrint}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderComplianceRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderComplianceRecords() && !shouldRenderFullPageError();
  const getInitialFilters = () => {
    const defaultFilters = {
      global: { value: null },
      makeTitle: { value: null, filterKey: "makeTitle" },
      modelTitle: { value: null, filterKey: "modelTitle" },
      extColor: { value: null, filterKey: "extColor" },
      ctTitle: { value: null, filterKey: "ctTitle" },
      locationTitle: { value: null, filterKey: "locationTitle" },
      plateNumber: { value: null, filterKey: "plateNumber" },
      vehicleNumber: { value: null, filterKey: "vehicleNumber" },
      vinNumber: { value: null, filterKey: "vinNumber" },
      vehicleStatus: { value: null, filterKey: "vehicleStatus" },
      status: { value: null, filterKey: "status" },
      crtBy: { value: null, filterKey: "crtBy" },
      crtTime: { value: null, filterKey: "crtTime" },
      modBy: { value: null, filterKey: "modBy" },
      modTime: { value: null, filterKey: "modTime" },
    };
    if (savedTableState?.filters) {
      Object.keys(savedTableState.filters).forEach(key => {
        if (defaultFilters[key]) {
          defaultFilters[key] = { ...defaultFilters[key], ...savedTableState.filters[key] };
        }
      });
    }
    return defaultFilters;
  };
  const filters = getInitialFilters();

  const getToastProps = () => {
    let toastTitle = "";
    if (isVehicleVehicleOperationsImportSuccess) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: `Import complete! ${vehicleImportResult?.successCount ?? 0} record(s) imported.`,
        shouldShowToast: true,
      };
    }
    if (isVehicleVehicleOperationsImportError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle: "Error while importing Vehicles!",
        shouldShowToast: true,
      };
    }
    if (isVehicleVehicleOperationsDeleteSuccess) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: "Vehicle deleted successfully!",
        shouldShowToast: true,
      };
    }
    if (isVehicleVehicleOperationsDeleteError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle: "Error while deleting Vehicle!",
        shouldShowToast: true,
      };
    }
    if (isCopy) {
      let toastTitle = "Data copied to clipboard!";
      if (!isCopy) {
        toastTitle = "Error while Data copied to clipboard!";
      }

      return {
        severity: isCopy ? TOAST_SEVERITY.SUCCESS : TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };

  const tableProps = {
    columns: tableData?.columns,
    paginationInfo,
    screenPermissions,
    value: tableData?.rows,
    emptyMessage: "No Vehicle found.",
    filters,
    loadLazyData: fetchVehicleVehicleOperationss,
    loading: isLoading,
    areFiltersVisible,
    showMoreActions: false,
    sortField: savedTableState?.sortField || 'id',
    initialSortOrder: savedTableState?.sortOrder,
    initialFirst: savedTableState?.first || 0,
    initialRows: savedTableState?.rows || 10,
    onTableStateChange,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    onDeleteRecord: deleteVehicleVehicleOperations,
    onEditRecord: editVehicleVehicleOperationsRoute,
    showViewButton: false,
    showCopyButton: false,
    showDeleteButton: true,
    showEditButton: true,
  };
  return (
    <>
      <Container maxWidth="lg">
        <Breadcrumb list={vehicleBreadcrumbD} />
        <EzToast {...getToastProps()} />
        {renderImportDialog()}
        <div className={`containerbox ${classes.bg}`}>
          {renderPageHeaderSection()}
          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldRenderComplianceRecords() && (
              <Box ref={tableRef} id="printable">
                <EzTable {...tableProps} />
              </Box>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No Vehicle records to show"}
              />
            )}
          </div>
        </div>
      </Container>
    </>
  );
};
export default VehicleVehicleOperations;
